<template>
  <div class="index" :class="{'iphone-x': iphoneX, 'show-banner': showDownBanner}" v-if="dataLoaded">
    <!-- <div class="search" @click="jumpSearch"></div> -->
    <download-banner
      :pageType="'index'"
      :link="'index'"
      :position="'top'"
      @close-banner="closeBanner"
      @banner-close="closeBanner">
    </download-banner>
    <search class="i-search"/>
    <cart />

    <div v-if="data.modules">
      <div v-for="(mod, index) in data.modules" :key="index" :style="renderModStyl(mod)">
        <image-banner 
        v-if="mod.type === 'image-banner' && mod.showFlag" 
        :data="mod.data"
        :modIndex="index" 
        :pageType="pageType" 
        :memberTags="data.memberTags" 
        paginateType="number"/>
        <image-index 
          v-if="mod.type === 'image-index' && mod.showFlag"
          :data="mod.data" 
          :modIndex="index" 
          :pageType="pageType" 
          :memberTags="data.memberTags" />
        <article-new 
          v-if="mod.type === 'new' && mod.showFlag"
          :data="mod.data"
          :modIndex="index" 
          :pageType="pageType" 
          :hideTitle="true"
          :memberTags="data.memberTags" />
        <!-- <fake-video  
          v-if="mod.type === 'video' && mod.showFlag"
          :data="mod.data" /> -->
        <article-video
          v-if="mod.type === 'video' && mod.showFlag" 
          :data="mod.data"
          :modIndex="index"
          :pageType="pageType"
          :multiVideo="multiVideo" />
        <article-image 
          v-if="mod.type === 'image' && mod.showFlag" 
          :data="mod.data"
          :modIndex="index" 
          :pageType="pageType" />
        <new-image 
          v-if="mod.type === 'new-image' && mod.showFlag"
          :data="mod.data"
          :modIndex="index" 
          :pageType="pageType" 
          :memberTags="data.memberTags"/>
        <new-banner
          v-if="mod.type === 'new-banner' && mod.showFlag" 
          :data="mod.data"
          :modIndex="index" 
          :pageType="pageType" 
          :memberTags="data.memberTags"/>
        <new-line
          v-if="mod.type === 'new-line' && mod.showFlag"
          :data="mod.data"
          :modIndex="index" 
          :pageType="pageType" />
        <new-list
          v-if="mod.type === 'new-list' && mod.showFlag"
          :data="mod.data"
          :modIndex="index" 
          :pageType="pageType" />
        <new-time
          v-if="mod.type === 'new-time' && mod.showFlag"
          :data="mod.data"
          :modIndex="index" 
          :pageType="pageType" />
        <article-buoy
          v-if="mod.type === 'buoy' && mod.showFlag"
          :data="mod.data"
          :modIndex="index" 
          :pageType="pageType"
          :memberTags="data.memberTags" />
      </div>
    </div>
    
    <navbar-bottom activeIndex="0"/>
    <upgrade-pop
      v-if="upgradePopData"
      :data="upgradePopData"
      :dialog="dialog"
      @upgrade-close="closeUpgradePopAction"
    />
    <pop-com
      v-if="showPopFlag"
      :id="popId"
      :name="popName"
      :image="popImage" 
      :link="popLink" 
      :dialog="dialog" 
      @pop-close="closePopAction"
    />
  </div>
</template>

<script>
  import { Page } from '@/page'
  import { lazyload } from '@/lazyload'
  // import track from '@/track'
  import axios from '@/axios-mock'
  import browser from '@beastshop/browser'
  import querystring from 'query-string'
  // import { scmAjax } from './lib/util.js'

  import wechatShare from '@/wechat-share'
  import { formatModules, formatTrackDataModules, scmAjax, getClientWidth } from '@/renderer-config/lib/util.js'
  import { isIphoneX } from '@/util'
  import { formatTime, addZero } from '@/time'

  import imageBanner from '@/renderer-config/components/image-banner'
  import articleNew from '@/renderer-config/components/new'
  import imageIndex from '@/renderer-config/components/image-index'
  import articleImage from '@/renderer-config/components/image'
  import newImage from '@/renderer-config/components/new-image'
  import newBanner from '@/renderer-config/components/new-banner'
  import newLine from '@/renderer-config/components/new-line'
  import newList from '@/renderer-config/components/new-list'
  import newTime from '@/renderer-config/components/new-time'
  import articleVideo from '@/renderer-config/components/video'
  import articleBuoy from '@/renderer-config/components/buoy'

  import Search from '@/components/search'
  import Cart from '@/components/cart'
  import downloadBanner from '@/components/download-banner'
  import navbarBottom from '@/components/navbar-bottom/index.vue'
  import popCom from './components/pop.vue'
  import upgradePop from './components/upgrade-pop.vue'
  // import fakeVideo from './components/fake-video.vue'
  
  const search = location.search.slice(1)
  const urlParams = querystring.parse(search)
  const clientWidth = getClientWidth()
  const baseWidth = 375

  import Exposure from './observe'

  export default {
    name: 'index',
    data () {
      return {
        pageType: 'index',
        data: {},
        dataLoaded: false,
        iphoneX: isIphoneX(),
        showDownBanner: false,
        popId: null,
        popName: '',
        popImage: null,
        popLink: null,
        showPopFlag: false,
        dialog: {
          mask: true,
          show: true,
          maskOpacity: '0.7'
        },
        upgradePopData: null,
        multiVideo: false
      }
    },
    created () {
      const env = urlParams.env || ''
      if(env === 'dy') {
        sessionStorage.setItem('dy-downloader', 'close')
      }
      
      this.$showLoading()
      this.getIndexData()
    },

    components: {
      imageBanner,
      articleNew,
      imageIndex,
      // fakeVideo,
      Search,
      Cart,
      downloadBanner,
      navbarBottom,
      articleImage,
      popCom,
      newImage,
      newBanner,
      newLine,
      newList,
      newTime,
      articleVideo,
      upgradePop,
      articleBuoy
    },

    methods: {
      getIndexData() {
        this.getIndex()
        .then(({ data }) => {
          this.$hideLoading()
          // data.modules = formatModules(data.modules)
          const modules = formatModules(data.modules, data.memberTags)

          let videoNum = 0
          modules.forEach((mod, index) => {
            const modType = mod.type
            const modData = mod.data
            mod.data.paddingData = {
              pl: modData.leftPadding?Number(modData.leftPadding):0,
              pr: modData.rightPadding?Number(modData.rightPadding):0,
              pt: modData.topPadding?Number(modData.topPadding):0,
              pb: modData.bottomPadding?Number(modData.bottomPadding):0
            }

            if(modType === 'video' && mod.showFlag) {
              if(modData.src) {
                videoNum++
              }
            }

            if((modType === 'new-image' || modType === 'new-banner') && mod.showFlag) {
              modData.items.forEach(item => {
                const url = item.media && item.media.src
                if(url && url.substring(url.lastIndexOf('.')).toLowerCase() === '.mp4') {
                  videoNum++
                }
              })
            }
          })
          if(videoNum > 1) {
            this.multiVideo = true
          }

          data.modules = formatTrackDataModules(modules, this.pageType)
          this.data = data
          this.dataLoaded = true
          this.$nextTick(() => {
            lazyload()
            // 神策曝光打点
            const exposurer = new this.$exposure((node) => {
              // console.log(node, '曝光啦')
              let trackData = node.getAttribute('data-trackdata') || "{}"
              trackData = JSON.parse(trackData)
              sa.track('HomePageAdvertiseExposure', trackData)
            })

            exposurer.observe('.client-item-box')
          })

          // this.getPopData()
          this.getUpgradePopData()
        })
        .catch(({ message }) => {
          this.$hideLoading()
          this.$alert(message)
        })
      },

      renderModStyl (mod) {
        const ratio = clientWidth/baseWidth
        let data = mod.data
        const {
          pl,
          pr,
          pt,
          pb
        } = data.paddingData
        let modStyl = {
          'padding-left': `${ratio*pl}px`,
          'padding-right': `${ratio*pr}px`,
          'padding-top': `${ratio*pt}px`,
          'padding-bottom': `${ratio*pb}px`
        }
        
        return modStyl
      },

      getUpgradePopData () {
        this.getUpgradePop()
        .then(({ data }) => {
          // this.upgradePopData = {
          //   levelIcon: 'http://img.thebeastshop.com/member/privilege/upgrade-icon/level-one.jpg',
          //   level: 0,
          //   title: 'dsjsdjkdkjskdkd',
          //   desc: 'dsjjfdsjkdjkdsjkdskkdskdsksdk',
          //   vipBenefits: [
          //     {
          //       icon: 'http://img.thebeastshop.com/member/privilege/upgrade-icon/level-one.jpg',
          //       name: '生日折扣'
          //     },
          //     {
          //       icon: 'http://img.thebeastshop.com/member/privilege/upgrade-icon/level-one.jpg',
          //       name: '生日到店礼'
          //     },
          //     {
          //       icon: 'http://img.thebeastshop.com/member/privilege/upgrade-icon/level-one.jpg',
          //       name: '松鼠礼包'
          //     }
          //   ]
          // }
          // return

          if(data && data.notices && data.notices.length) {
            this.upgradePopData = data.notices[0]
            console.log(this.upgradePopData, 'upgradePopData')
          } else {
            this.getPopData()
          }
        })
        .catch(err => {
          console.log(err, "getPop发生了错误")
        })
      },

      getPopData () {
        this.getPop()
        .then(({ data }) => {
          if(data) {
            // this.popData = data
            this.popId = data.id
            this.popName = data.name
            this.popImage = data.openImageInfoObj.image || {}
            this.popLink = data.openImageInfoObj.links.m || {}

            this.formatPopData(data)
          }
        })
        .catch(err => {
          // this.$alert(message)
          console.log(err, "getPop发生了错误")
        })
      },

      formatPopData (data) {
        const id = data.id || ''
        const popId = localStorage.getItem('pop-id')
        if(popId !== id+'') {//更换弹框
          localStorage.setItem('pop-id', id)
          localStorage.removeItem('only-one')
          localStorage.removeItem('day-one')
        }

        const showWay = data.showWay
        if(showWay === 0) {//仅弹一次
          const onlyOne = localStorage.getItem('only-one')
          if(!onlyOne) {//没弹过
            localStorage.setItem('only-one', 'one')
            this.showPopFlag = true
          }
        }
        if(showWay === 1) {//一天一次
          let dayOne = localStorage.getItem('day-one')
          dayOne = parseInt(dayOne || 0)
          const now = formatTime(new Date().getTime())
          const nowDate = parseInt(now.year+''+addZero(now.month)+''+addZero(now.day))
          if(nowDate > dayOne) {
            localStorage.setItem('day-one', nowDate)
            this.showPopFlag = true
          }
        }

        console.log(this.showPopFlag)
      },

      getIndex () {
        return axios({
          url: '/app/index/getNewIndex'
        })
      },

      getUpgradePop () {
        return axios({
          url: '/app/notice/level_upgrade'
        })
      },

      getPop () {
        return axios({
          url: '/appadmin/store/getPopupByPlatform'
        })
      },

      closeBanner () {
        this.showDownBanner = false
      },

      closeUpgradePopAction () {
        this.upgradePopData = null
      },

      closePopAction () {
        this.showPopFlag = false
      },
    }
  }
</script>

<style lang="stylus" src="./index.styl"></style>



// WEBPACK FOOTER //
// index.vue?6a687f01